import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { encrypt } from "../utils/crypto";

const EmployeeQuickLinks = ({ employee_id, basicDetails }) => {
  const encryptedEmployeeId = encrypt(employee_id);
  const navigate = useNavigate();

  const getEmployeeName = () => {
    return (
      (basicDetails?.first_name ?? "") +
      " " +
      (basicDetails?.middle_name ? basicDetails?.middle_name + " " : "") +
      (basicDetails?.last_name ?? "")
    ).trim();
  };

  const navigationItems = [
    {
      icon: "text-primary fa-calendar-days",
      title: "Attendance",
      path: `../attendance-employee/${encryptedEmployeeId}`,
    },
    {
      icon: "text-primary fa-address-card",
      title: "Leave dashboard",
      path: `../leave-dashboard/${encryptedEmployeeId}`,
    },
    {
      icon: "text-primary fa-umbrella-beach",
      title: "Leaves",
      path: `../leaves-employee/${encryptedEmployeeId}`,
    },
    {
      icon: "text-primary fa-sack-dollar",
      title: "Reimbursement",
      path: `../reimbursement/${encryptedEmployeeId}`,
    },
    // {
    //   icon: "text-primary fa-list-check",
    //   title: "Task box",
    //   path: `../taskbox/${encryptedEmployeeId}`,
    // },
    {
      icon: "text-primary fa-wallet",
      title: "Salary",
      path: `../mypay/${encryptedEmployeeId}`,
    },
    {
      icon: "text-primary fa-laptop-file",
      title: "Assigned Assets",
      path: `../assigned-asset/${encryptedEmployeeId}`,
    },
    {
      icon: "text-primary fa-folder-open",
      title: "Documents",
      path: `../my-document/${encryptedEmployeeId}`,
      iconPrefix: "fa-regular",
    },
    {
      icon: "text-primary fa-location-dot",
      title: "Location",
      path: `../employee-locations?employee_id=${encryptedEmployeeId}`,
    },
    {
      icon: "text-primary fa-briefcase",
      title: "Work Status",
      path: `../employee-work-status?employee_id=${encryptedEmployeeId}`,
    },
  ];

  return (
    <div className="text-center">
      <Row>
        {navigationItems.map((item, index) => (
          <Col key={index} xs={3} sm={3} md={2} lg={1} className="mb-3">
            <i
              className={`${item.iconPrefix || "fa-solid"} ${
                item.icon
              } fa-2x btn p-2`}
              title={item.title}
              onClick={() =>
                navigate(item.path, {
                  state: { employeeName: getEmployeeName() },
                })
              }
              style={{ cursor: "pointer" }}
            ></i>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default EmployeeQuickLinks;
